import React from 'react';

function GPSTable(props){
  if(!props.gpsActions || props.gpsActions.length === 0){
    return null;
  }
  else{
    return(
        <div className="detail-row">
          <table className="cdb-small-table">
            <tbody>
              <tr>
                <th>Tech Cnt</th>
                <th>Status</th>
                <th>Date</th>
                <th>Time</th>
              </tr>
              {props.gpsActions.map((row) => {
                let datetime = new Date(row.dateTimeStamp + 'Z');
                let hours = datetime.getHours();
                let minutes = datetime.getMinutes();
                let ampm = hours >= 12 ? 'pm' : 'am';
                minutes = minutes < 10 ? `0${minutes}` : minutes;
                let time = `${hours % 12}:${minutes} ${ampm}`;
                let techCount = row.techCount > 0 ? row.techCount : '';
  
                return (
                  <tr key={row.id}>
                    <td>{techCount}</td>
                    <td>{row.transactionType.replace('Check', 'Check-')}</td>
                    <td>{datetime.getMonth() + 1}/{datetime.getDate()}/{datetime.getFullYear()}</td>
                    <td>{time}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
    );
  }
}

export default GPSTable;